import { c as _c } from "react/compiler-runtime";
export const MenuLink = t0 => {
  const $ = _c(12);
  const {
    title,
    href,
    img,
    isNoFollow
  } = t0;
  let t1;
  if ($[0] !== isNoFollow) {
    t1 = isNoFollow && {
      rel: "nofollow"
    };
    $[0] = isNoFollow;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== img || $[3] !== title) {
    t2 = <img alt={title} className="h-14 w-14 shrink-0 rounded-lg max-sm:h-12 max-sm:w-12" loading="lazy" src={img} />;
    $[2] = img;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== title) {
    t3 = <span className="text-subtitle-1 text-on-surface-high-emphasis inline-block truncate whitespace-nowrap">{title}</span>;
    $[5] = title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== href || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <li className="max-sm:border-outline-thin w-full py-2 last:border-none max-sm:border-b lg:w-60 xl:w-72"><a href={href} className="flex items-center gap-4" {...t1}>{t2}{t3}</a></li>;
    $[7] = href;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};